import { ca } from '@cian/analytics';

import { FOfferType } from '../../../../utils/category';

export const OFFER_TYPE_TRACKING_LABEL: { [key: number]: string } = {
  [FOfferType.FlatOld]: 'flatold',
  [FOfferType.FlatNew]: 'flatnew',
  [FOfferType.Flat]: 'flat',
  [FOfferType.Room]: 'room',
  [FOfferType.Bed]: 'bed',
  [FOfferType.Urban]: 'urban',
  [FOfferType.FlatShared]: 'flatshared',
  [FOfferType.House]: 'house',
  [FOfferType.HousePart]: 'housepart',
  [FOfferType.Townhouse]: 'townhouse',
  [FOfferType.Land]: 'land',
  [FOfferType.Suburban]: 'suburban',
  [FOfferType.Residential]: 'residential',
  [FOfferType.Garage]: 'garage',
};

export function trackEmptyListingLinkClick(offerType: FOfferType, oid: number) {
  ca('event', {
    action: 'emptylisting_in_KP',
    category: 'Listing',
    label: OFFER_TYPE_TRACKING_LABEL[offerType],
    name: 'oldevent',
    oid,
  });
}
